import '@babel/polyfill';
import '@/assets/styles';
import Vue from 'vue';
import '@/api';
import router from '@/router';
import store from '@/store';
import App from '@/App';
import 'view-design/dist/styles/iview.css';
import { Message, Modal } from 'view-design';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import 'echarts';
import ECharts from 'vue-echarts/components/ECharts.vue';
import Moment from 'moment';

Vue.component('v-chart', ECharts);

Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: false,
    title: false,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: false,
    scalable: true,
    transition: false,
    fullscreen: true,
    keyboard: true,
    url: 'data-source',
  },
});

/* 全局挂载 */
Vue.prototype.$Message = Message;
Vue.prototype.$Modal = Modal;
Vue.prototype.moment = Moment;
// Vue.prototype.$Echarts = echarts;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
